import * as React from "react";

import { reject } from "../../../../../Common/TypingUtils";

export interface IFixedTabsContext {
    register(id: string, renderTitle: () => React.ReactNode): () => void;
    setCurrentTab(id: string): void;

    readonly currentId: undefined | string;
}

const FixedTabsContext = React.createContext<IFixedTabsContext | undefined>(undefined);

export function useFixedTabsContext(): IFixedTabsContext {
    return React.useContext(FixedTabsContext) ?? reject("FixedTabsContext");
}

export const FixedTabsContextProvider = FixedTabsContext.Provider;
